export const IconActionReject: {
  name: 'icon_action_reject-7a88175250c4'
} = {
  name: 'icon_action_reject-7a88175250c4'
}
